<form [formGroup]="configurationFormFileName">
  <div class="form-row row">
    <div class="form-group col-12">
      <label for="fileName"
             class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.file-name' | translate}}</label>
      <input id="fileName"
             type="text"
             formControlName="fileName"
             class="form-control"/>
      <app-error-messages [control]="configurationFormFileName.get('fileName')"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="col-12">
      <div class="mx-auto">
<!--    Todo: create evaluation of filename -->
        <button type="button"
                class="btn btn-outline-secondary me-3"
                style="float: left"
                (click)="this.evaluateFileName()"
                [disabled]="!configurationFormFileName.valid">
          {{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.button-evaluate' | translate}}
        </button>
        @if (this.fileNameResult) {
          <div style="float: left">
            <span>{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.result' | translate}}:</span><br>
            <span id="result">{{this.fileNameResult}}</span>
          </div>
        }
      </div>
    </div>
  </div>
</form>
<div class="form-row row mt-3">
  <div class="col-12">
    <ejs-grid #grid
              width="100%"
              rowHeight="38"
              class="grid-no-filter"
              [dataSource]="data"
              [allowSorting]="true"
              [allowFiltering]="true"
              [filterSettings]="filterSettings"
              [allowPaging]="false"
              (recordDoubleClick)="onCopyRecordValue($event)">
      <e-columns>
        <e-column field="placeholder"
                  headerText="{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.placeholder' | translate}}"
                  width="200"
                  clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column field="description"
                  headerText="{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.description' | translate}}"
                  clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            <div innerHTML="{{data.description}}"></div>
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
